import { type UiI18n } from '@myre/domain-i18n-wordings';

import { type IFooterLinks } from './footer.component';

type FooterWordings = UiI18n['_ui']['footer'];

/** `helpUrl` is an absolute URL, the other links read theirs from the wordings. */
export function getFooterLinks(
  helpUrl: string,
  footer: FooterWordings,
): IFooterLinks[] {
  return [
    {
      header: footer.myre.header(),
      items: [
        {
          name: footer.myre.userGuide.name(),
          url: helpUrl,
          isActive: true,
          isUserGuide: true,
          target: '_blank',
        },
        {
          name: footer.myre.solution.name(),
          url: footer.myre.solution.url(),
          isActive: true,
          target: '_blank',
        },
        {
          name: footer.myre.about.name(),
          url: footer.myre.about.url(),
          isActive: true,
          target: '_blank',
        },
        {
          name: footer.myre.customerExperiences.name(),
          url: footer.myre.customerExperiences.url(),
          isActive: true,
          target: '_blank',
        },
      ],
    },
    {
      header: footer.resources.header(),
      items: [
        {
          name: footer.resources.blog.name(),
          url: footer.resources.blog.url(),
          isActive: true,
          target: '_blank',
        },
        {
          name: footer.resources.press.name(),
          url: footer.resources.press.url(),
          isActive: true,
          target: '_blank',
        },
        {
          name: footer.resources.jobs.name(),
          url: footer.resources.jobs.url(),
          isActive: true,
          target: '_blank',
        },
        {
          name: footer.resources.mediaKit.name(),
          url: footer.resources.mediaKit.url(),
          isActive: true,
          target: '_blank',
        },
      ],
    },
    {
      header: footer.contact.header(),
      items: [
        {
          name: footer.contact.linkedIn.name(),
          url: footer.contact.linkedIn.url(),
          isActive: true,
          target: '_blank',
        },
        {
          name: footer.contact.twitter.name(),
          url: footer.contact.twitter.url(),
          isActive: true,
          target: '_blank',
        },
        {
          name: footer.contact.facebook.name(),
          url: footer.contact.facebook.url(),
          isActive: true,
          target: '_blank',
        },
      ],
    },
    {
      header: footer.legal.header(),
      items: [
        {
          name: footer.legal.cookiesPolicy.name(),
          url: footer.legal.cookiesPolicy.url(),
          isActive: true,
          target: '_blank',
        },
        {
          name: footer.legal.legalInformation.name(),
          url: footer.legal.legalInformation.url(),
          isActive: true,
          target: '_blank',
        },
        {
          name: footer.legal.terms.name(),
          url: footer.legal.terms.url(),
          authRequired: true,
          isActive: true,
          target: '_blank',
        },
        {
          name: footer.legal.privacyPolicy.name(),
          url: footer.legal.privacyPolicy.url(),
          isActive: true,
          target: '_blank',
        },
        {
          name: footer.legal.gdpr.name(),
          url: footer.legal.gdpr.url(),
          isActive: true,
          target: '_blank',
        },
      ],
    },
  ];
}
